/*
id: contrast
name: Contrast
author: Default
borders: true
*/
body {
	--color-ui: #17191d;
	--color-back: #17191d;
	--color-dark: #17191d;
	--color-border: #9ea4b5;
	--color-selected: #31525f;
	--color-button: #3a3f4b;
	--color-bright_ui: #17191d;
	--color-accent: #1b71d9;
	--color-frame: #121418;
	--color-text: #d0d0db;
	--color-light: #f4f3ff;
	--color-accent_text: #eeeef5;
	--color-bright_ui_text: #d0d0dd;
	--color-subtle_text: #adb2bc;
	--color-grid: #727683;
	--color-wireframe: #5f96bc;
	--color-checkerboard: #1c2026;
}


#mode_selector li {
	padding: 2px 10px;
}
#mode_selector li.selected {
	background-color: var(--color-accent);
	color: var(--color-accent_text);
}
#mode_selector > li:not(.selected) > .icon {
    color: inherit;
}

#tab_bar .project_tab.selected,
.dialog_sidebar_pages li.selected,
.tool.enabled
{
	background-color: var(--color-accent) !important;
	color: var(--color-accent_text);
}
.contextMenu li:not(.menu_separator) {
	height: 34px;
	padding-top: 6px;
	padding-bottom: 6px;
}
.dialog_sidebar_pages li.selected {
	background-color: var(--color-accent) !important;
	color: var(--color-accent_text);
}
.dialog_handle {
	background: var(--color-ui);
}
.controller_state_gate {
	background-color: var(--color-border);
}
.controller_state_title_bar {
	background-color: transparent;
	 border-bottom: 1px solid var(--color-border)
}
#theme_list .theme {
    background-color: transparent;
	box-shadow: none;
	border: 2px solid var(--color-border);
}
#theme_list .theme.selected {
    border-color: var(--color-accent);
}
.elevated {
    background-color: transparent;
    border: 2px solid var(--color-border);
    border-radius: 4px;
}
#tab_bar .project_tab {
	border-radius: 3px;
}
#tab_bar .project_tab.selected::before, #tab_bar .project_tab.selected::after {
    display: none;
}
input[type=checkbox].toggle_switch {
	height: 24px;
	background: var(--color-ui);
    border: 1px solid var(--color-border);
}
input[type=checkbox].toggle_switch:checked {
	background-color: var(--color-accent);
}